import { DashboardPanel } from "@/features/dashboard/DashboardPanel"

export function DashboardPage() {
    return (
        <DashboardPanel />
    )
}